export default theme => ({
    avatarBreakdown: {
        position: 'relative',
        marginBottom: 36,
        [theme.breakpoints.up('md')]: {
            paddingTop: 14,
        },
        '& .gatsby-image-wrapper': {
            width: 56,
            marginRight: 14,
            float: 'left',
            [theme.breakpoints.up('md')]: {
                marginTop: -14,
                width: 90,
                marginRight: 24,
            }
        },
        '& p': {
            marginBottom: 0,
            '&:nth-of-type(1)': {
                fontWeight: 'bold',
            },
            '&:nth-of-type(2)': {
                fontStyle: 'italic',
            }
        }
    },
    avatarBreakdownTheme: {
        ...theme.avatarBreakdownTheme
    },
});